<div ng-controller="extendContractController as ctrl">
    <c-auto-form config="ctrl.autoFormConfig" class="modal-view user-settings"></c-auto-form>
</div>